import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["form", "fileInput", "signedId", "filename", "allCheckbox", "roleCheckbox", "submitButton", "error"]
  static values = { directUploadUrl: String }

  toggleAll() {
    const checked = this.allCheckboxTarget.checked
    this.roleCheckboxTargets.forEach((checkbox) => { checkbox.checked = checked })
  }

  syncAll() {
    this.allCheckboxTarget.checked = this.roleCheckboxTargets.every((checkbox) => checkbox.checked)
  }

  submit(event) {
    if (this.submittedAfterUpload) return

    event.preventDefault()
    this.hideError()

    const file = this.fileInputTarget.files[0]
    if (!file) {
      this.showError("Choose a document to upload.")
      return
    }

    if (!this.selectedRoles().length) {
      this.showError("Choose who can see this document.")
      return
    }

    this.submitButtonTarget.disabled = true
    const upload = new DirectUpload(file, this.directUploadUrlValue)
    upload.create((error, blob) => {
      if (error) {
        this.submitButtonTarget.disabled = false
        this.showError("The file could not be uploaded. Try again.")
        return
      }

      this.signedIdTarget.value = blob.signed_id
      this.filenameTarget.value = blob.filename
      this.submittedAfterUpload = true
      this.formTarget.requestSubmit()
    })
  }

  selectedRoles() {
    return this.roleCheckboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }

  hideError() {
    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""
  }
}
